import React from 'react';
import cn from 'classnames';

import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';
import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import Back from 'shared/ui/icons/General/Back';
import DateWithTodayYesterdayAccent from 'shared/ui/Date/DateWithTodayYesterdayAccent';
import IPortIncident from 'features/port/model/PortIncident/IPortIncident';
import usePortIncidentRow from 'features/port/model/usePortIncidentRow';
import {secondsToFormattedString} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';
import {getPortDesiredStateLabel} from 'features/port/lib/portMonitorHelper';

import PortIncidentModal from '../PortIncidentModal/PortIncidentModal';
import PortIncidentStatusBadge from '../PortIncidentStatusBadge/PortIncidentStatusBadge';

import styles from './PortIncidentRow.module.scss';

interface IPortIncidentRowProps {
    item: IPortIncident,
    tzString?: string | null,
    hideMonitor?: boolean,
}

const PortIncidentRow: React.FC<IPortIncidentRowProps> = ({item, tzString, hideMonitor = false}) => {
    const {
        isOpen,
        name,
        address,
        durationSeconds,
        isModalOpen,
        closeModal,
        onRowClick,
        onButtonClick,
    } = usePortIncidentRow(item, hideMonitor);

    return (
        <>
            <tr className={cn(styles.tr, 'clickable')} onClick={onRowClick}>
                <td>
                    <div className={styles.blockIncidentStatus}>
                        {isOpen ? <ProblemMonitor/> : <SuccessfulMonitor/>}
                        <PortIncidentStatusBadge
                            isOpen={isOpen}
                            className={cn(styles.status, isTranslate() && styles.statusTranslate)}
                        />
                    </div>
                </td>
                {!hideMonitor && (
                    <td className={styles.blockName}>
                        <div className={styles.containerName}>
                            <span title={name}>{name}</span>
                        </div>
                        {address !== name && <span className={styles.address}>{address}</span>}
                    </td>
                )}
                <td>{getPortDesiredStateLabel(item.desired_state)}</td>
                <td><DateWithTodayYesterdayAccent datetime={item.created_at} tzString={tzString}/></td>
                <td><DateWithTodayYesterdayAccent datetime={item.resolved_at} tzString={tzString}/></td>
                <td className={styles.duration}>{secondsToFormattedString(durationSeconds)}</td>
                <td onClick={onButtonClick}>
                    <span className={styles.icon}>
                        <Back/>
                    </span>
                </td>
            </tr>

            <PortIncidentModal
                uuid={item.uuid}
                monitorName={name}
                isOpen={isModalOpen}
                handleClose={closeModal}
                tzString={tzString}
            />
        </>
    );
};

export default PortIncidentRow;
